export default __webpack_public_path__ + "static/media/news6.931efc35.webp";